"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPreviewProductsWidgetContainer = exports.StyledSettingsWidget = exports.StyledStrategyPreviewWidget = exports.StyledPageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const widget_1 = require("./components/widget");
exports.StyledPageContainer = styled_components_1.default.div `
  display: grid;
  flex: 1;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  column-gap: ${({ theme }) => theme.spacing(1)};       
  max-height: calc(100vh - 7rem);

  &.workspace {
    grid-template-columns: 300px 1fr;
    grid-template-rows: auto auto 1fr;
    grid-template-areas: 'title title'
                         'settings preview-products-widget'
                         'strategy-preview-widget preview-products-widget';

    .last-synced-label {
      display: flex;
      align-items: center;
    }
  }

  &.dashboard {
    gap: ${({ theme }) => theme.spacing(2)};  
    grid-template-columns: 1fr 1fr 2fr;
    grid-template-rows: repeat(6, min-content) max-content;
    grid-template-areas: 
      'title title title'
      'selectors selectors .'
      'product-catalog-widget product-catalog-widget attribute-distribution-widget'
      'category-select-widget . attribute-distribution-widget'
      'product-status-widget attribute-breakdown-widgets attribute-distribution-widget'
      'attributions-widget attributions-widget attribute-distribution-widget'
      'hlqa-task-view-widget hlqa-task-view-widget hlqa-task-view-widget';
  }

  &.dashboard-hlqa-only {
    gap: ${({ theme }) => theme.spacing(2)};
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
    grid-template-areas:
      'title'
      'selectors'
      'hlqa-task-view-widget';
  }

  &.task-view {
    grid-template-columns: 1fr;
    grid-template-rows: max-content 1fr;
    grid-template-areas:
      'title title'
      'body body';
    height: 100%;

    &.sidebar-open {
      grid-template-columns: 435px 1fr;
      grid-template-areas:
        'title title'
        'sidebar body';
    }
  }
  
  & > .title {
    grid-area: title;
    padding: ${({ theme }) => theme.spacing(2, 0, 1, 0)};

    .page-title-header-container {
      flex-basis: auto;
    }
    
    & > div:last-child {
      display: flex;
      gap: ${({ theme }) => theme.spacing(1)};
    }

    .title-action {
      background-color: ${({ theme }) => theme.palette.common.white};

      svg path {
        fill: none;
      }
      .loading-indicator svg path {
        fill: currentColor;
      }
    }
  }

  max-height:  ${({ theme }) => `calc(100vh - ${theme.footer.height} - ${theme.appHeader.height})`};
`;
exports.StyledStrategyPreviewWidget = (0, styled_components_1.default)(widget_1.Widget) `
  grid-area: strategy-preview-widget;

  overflow: hidden;
  .widget-title {
    font-size: 1.125rem;
  }
`;
exports.StyledSettingsWidget = (0, styled_components_1.default)(widget_1.Widget) `
  grid-area: settings;
  gap: 0;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledPreviewProductsWidgetContainer = styled_components_1.default.div `
  grid-area: preview-products-widget;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;
